import React from "react";
import NodeGlyph from "../revenue-path/NodeGlyph";

const STEPS = [
  {
    n: "01",
    state: "healthy",
    title: "Audit",
    body: "We review the current path from lead to booked revenue.",
  },
  {
    n: "02",
    state: "healthy",
    title: "Map",
    body: "We identify the simplest system needed to fix the leak.",
  },
  {
    n: "03",
    state: "healthy",
    title: "Build",
    body: "We create the website, capture path, CRM flow, booking/payment path, follow-up, and reporting pieces needed.",
  },
  {
    n: "04",
    state: "healthy",
    title: "QA",
    body: "We test the path before calling it ready.",
  },
  {
    n: "05",
    state: "recovered",
    title: "Handoff",
    body: "You receive a clean operating view of what was built and how to use it.",
  },
];

/** "How it works" — the Audit → Map → Build → QA → Handoff engagement steps. */
export default function AuditProcess() {
  return (
    <section
      data-testid="audit-process-section"
      className="bg-sand-100 px-5 sm:px-6 md:px-10 py-16 sm:py-20 md:py-24"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl reveal">
          <p className="eyebrow">The Engagement</p>
          <h2
            data-kinetic
            className="font-display mt-4 sm:mt-5 text-3xl sm:text-4xl md:text-5xl lg:text-[3rem] leading-[1.06] tracking-[-0.02em] font-semibold text-ink"
          >
            How it{" "}
            <span className="italic font-normal text-ink-muted">works.</span>
          </h2>
        </div>

        <ol className="mt-10 sm:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-0 sm:gap-0">
          {STEPS.map((s, idx) => (
            <li
              key={s.title}
              data-testid={`process-step-${idx}`}
              className="reveal relative border-t border-sand-300 pt-6 pr-5 pb-6 lg:pb-0"
            >
              {/* path connector into next node */}
              {idx < STEPS.length - 1 && (
                <span className="hidden lg:block absolute top-0 left-0 right-0 -translate-y-1/2 h-px">
                  <span className="block h-px w-full bg-sand-300" />
                </span>
              )}
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-clay-deep">
                  Path {s.n}
                </span>
                <NodeGlyph state={s.state} size={20} />
              </div>
              <h3 className="font-display mt-5 text-xl font-semibold tracking-tight text-ink">
                {s.title}
              </h3>
              <p className="mt-2.5 text-[14px] leading-relaxed text-ink-muted">
                {s.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
